export default "__VITE_ASSET__b4f80c1f__"